import React, { useEffect, useState } from 'react'

import { ContainerCard } from '../../reusable-components/AgiliteCards'
import { Col, message } from 'antd'

import { handleError } from '../../lib/utils'
import CoreEnums from '../../../core/utils/enums'
import CustomRow from '../../reusable-components/CustomRow'
import ClinicalReportingTemplatesListView from './clinical-reports-list-view'
import { readClinicalReportTemplates } from './utils/clinical-reporting-utils'

const ClinicalReportingTemplatesWrapper = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    handleGetData()
  }, [])

  const handleGetData = async () => {
    setLoading(true)
    try {
      const response = await readClinicalReportTemplates({})
      setData(response)
    } catch (e) {
      message.error(handleError(e, true))
    }
    setLoading(false)
  }

  return (
    <ContainerCard title={CoreEnums.tabTitles.DATA_POINT_TEMPLATES}>
      <CustomRow justify='center'>
        <Col xs={24} sm={24} md={18} lg={16}>
          <ClinicalReportingTemplatesListView data={data} loading={loading} handleGetData={handleGetData} />
        </Col>
      </CustomRow>
    </ContainerCard>
  )
}

export default ClinicalReportingTemplatesWrapper
